import { Component, OnDestroy, OnInit } from '@angular/core';
import { AcModel } from '../../../models/ac.model';
import { ApiService } from '../../../services/api.service';
import { AuthStateService } from '../../../services/auth-state.service';
import { DataService } from '../../../services/data.service';
import { UiService } from '../../../services/ui.service';
import {
  faFolders,
  faEdit,
  faStreetView,
  faUsers,
  faCalendarAlt,
  faBullhorn,
  faUserLock,
  faPhone,
  faEnvelope,
  faClipboard,
  faClock,
  faRunning,
  faCheckCircle as faCheckCircleLight,
  faGlobe,
  faPlayCircle
} from '@fortawesome/pro-light-svg-icons';
import {
  faCheckCircle,
} from '@fortawesome/pro-solid-svg-icons';
import * as moment from 'moment';
import { TranslocoService } from '@ngneat/transloco';
import { TimezoneService } from '../../../services/timezone.service';
import { TimingService } from '../../../services/timing.service';
import { Subscription } from 'rxjs';
import { CandidateModel } from '../../../models/candidate.model';
import { Router } from '@angular/router';
import { AppService } from '../../../services/app.service';

enum FinishModes {
  Finish = 'finish',
  Incomplete = 'incomplete',
  Terminate = 'terminate'
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {

  public ac: AcModel = null;
  public acSubscription: Subscription = null;
  public starting = false;
  public finishing = false;
  public terminating = false;
  public clock: any = null;
  public finishVisible = false;
  public finishMode: FinishModes;
  public FinishModes = FinishModes;
  public incompleteCandidates: Array<CandidateModel> = [];

  public faFolders = faFolders;
  public faEdit = faEdit;
  public faStreetView = faStreetView;
  public faUsers = faUsers;
  public faCalendarAlt = faCalendarAlt;
  public faBullhorn = faBullhorn;
  public faUserLock = faUserLock;
  public faPhone = faPhone;
  public faEnvelope = faEnvelope;
  public faClipboard = faClipboard;
  public faClock = faClock;
  public faCheckCircle = faCheckCircle;
  public faRunning = faRunning;
  public faCheckCircleLight = faCheckCircleLight;
  public faGlobe = faGlobe;
  public faPlayCircle = faPlayCircle;

  constructor(
    private data: DataService,
    private api: ApiService,
    private app: AppService,
    private ui: UiService,
    private timing: TimingService,
    private router: Router,
    public auth: AuthStateService,
    public transloco: TranslocoService,
    public timezone: TimezoneService
  ) { }

  ngOnInit(): void {
    this.timing.clock$.subscribe({next: (clock: any) => this.clock = clock});
    this.acSubscription = this.data.ac$.subscribe({
      next: (ac: AcModel) => {
        if (ac !== null) {
          this.ac = ac;
          this.data.setActiveNav('dashboard');
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.acSubscription !== null) {
      this.acSubscription.unsubscribe();
      this.acSubscription = null;
    }
  }

  public startAc(): void {
    this.starting = true;
    this.api.startAc().subscribe({
      next: (result: any) => {
        this.data.setNewAcStatus(result.data);
      },
      error: (error: any) => {
        this.ui.showMessage('error', error, this.transloco.translate('common.messages.error'));
      }
    }).add(() => {
      this.starting = false;
    });
  }

  public showFinishDialog(): void {
    this.finishVisible = true;
    if (this.ac.isFinishable()) {
      this.finishMode = FinishModes.Finish;
    } else {
      this.finishMode = FinishModes.Incomplete;
      this.incompleteCandidates = this.ac?.candidates?.filter((candidate: CandidateModel) => {
        return candidate.recommendation === null;
      });
    }
  }

  public hideFinishDialog(): void {
    this.finishVisible = false;
    this.finishMode = null;
  }

  public showTerminateDialog(): void {
    this.finishVisible = true;
    this.finishMode = FinishModes.Terminate;
  }

  public sendFinish(): void {
    this.finishing = true;
    this.api.finishAc().subscribe({
      next: (result: any) => {
        this.data.setNewAcStatus(result.data);
        this.finishVisible = false;
      },
      error: (error: any) => {
        this.ui.showMessage('error', error, this.transloco.translate('common.messages.error'));
      }
    }).add(() => {
      this.finishing = false;
    });
  }

  public sendTerminate(): void {
    this.terminating = true;
    this.api.terminateAc().subscribe({
      next: (result: any) => {
        this.data.setNewAcStatus(result.data);
        this.finishVisible = false;
      },
      error: (error: any) => {
        this.ui.showMessage('error', error, this.transloco.translate('common.messages.error'));
      }
    }).add(() => {
      this.terminating = false;
    });
  }

  public gotoConference(): void {
    this.router.navigate(['/ac/conference']);
  }

  public getVisibleMode(): string {
    if (this.auth.isModerator()) {
      return 'ac';
    } else {
      const startOfAcDay = this.ac.getAcDay();
      return (this.auth.isObserver() && moment().isAfter(startOfAcDay)) ? 'ac' : this.ac.getVisibleMode();
    }
  }

}
